import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress errors from browser extensions (MetaMask, etc.)
window.addEventListener("error", (e) => {
  if (e.message?.includes("MetaMask") || e.filename?.includes("chrome-extension")) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  if (e.reason?.message?.includes("MetaMask") || String(e.reason).includes("chrome-extension")) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
